module.exports = __webpack_public_path__ + "img/ic_new_holland.b4837d0a.png";